export const pluralize = (
  count: number,
  noun: string,
  suffix = "s",
  displayCount = true,
): string => `${displayCount ? count : ""} ${noun}${count !== 1 ? suffix : ""}`;

export const splitCamelCase = (text: string): string =>
  text.replace(/([a-z0-9])([A-Z])/g, "$1 $2");

export const normalize = (text: string): string =>
  text
    .replace(/[\s-]+/g, "_")
    .replace(/[^a-zA-Z0-9-_]/g, "")
    .toLowerCase();

export const generateToken = (length: number): string => {
  const a =
    "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890".split("");
  const b: string[] = [];
  for (let i = 0; i < length; i++) {
    const j = (Math.random() * (a.length - 1)).toFixed(0);
    b[i] = a[j];
  }
  return b.join("");
};

export const normalizeCommasValue = (
  text: string | undefined | null,
): string | undefined => {
  if (text) {
    return text.replace(/,\s*$/, "").replace(/^,\s*/, "");
  }
  return text || undefined;
};
